export const SGPLaunchDarklyModeKey = 'SGPMode';
export const ShowSGPBadgeOnEDPLaunchDarklyKey = 'ShowSGPBadgeOnEDP';
